import { ICategory } from 'src/models';

// 카테고리 선택 옵션 depth에 따라 표기되도록 구성하는 함수
export const buildCategoryOptions = (categories: ICategory[], depth = 0): any[] => {
  const currentLang = localStorage.getItem('i18nextLng') || 'ko';

  return categories.flatMap((ctegry) => {
    const indent = '⇢'.repeat(depth); // 들여쓰기 표시를 위해 depth만큼의 하이픈을 사용
    const categoryInfo = ctegry.categoryInfoList?.find((info) => info.langCd === currentLang);

    const baseOption = {
      value: ctegry.categorySid,
      label: `${indent} ${categoryInfo?.categoryNm || '-'}`,
    };

    const childOptions = ctegry.children ? buildCategoryOptions(ctegry.children, depth + 1) : [];

    return [baseOption, ...childOptions];
  });
};
